import { Component, Output, EventEmitter, Input } from '@angular/core';
import { QRInput } from 'src/app/models/qr-input.model';

@Component({
  selector: 'app-dialog-remove-agent',
  templateUrl: './dialog-remove-agent.component.html',
  styleUrls: ['./dialog-remove-agent.component.scss'],
})
export class DialogRemoveAgentComponent {
  @Input() deleteable: number | undefined; // 1 -> can delete, 2 -> can't delete
  @Output() changeDeleteableStatus: EventEmitter<number> =
    new EventEmitter<number>();

  inputString: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Nombre',
  };

  inputChange(deleteable: number): void {
    if (deleteable) {
      this.changeDeleteableStatus.emit(deleteable);
    }
  }
}
